var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef } from "react";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import calendar from "../assets/DateSelector/calendar.svg";
import { Container, Icon } from "./DateSelector.styles";
import "./DateSelector.scss";
import { useField, useFormikContext } from "formik";
var makeDate = function (dateStr) {
    var index = dateStr.indexOf("T");
    if (index !== -1) {
        dateStr = dateStr.substr(0, index);
    }
    return new Date(dateStr + "T00:00");
};
export var DateSelector = function (_a) {
    var datePickerProps = _a.datePickerProps, props = __rest(_a, ["datePickerProps"]);
    var setFieldValue = useFormikContext().setFieldValue;
    var _b = __read(useField(props), 1), field = _b[0];
    useEffect(function () {
        if (typeof field.value === "string") {
            setFieldValue(field.name, makeDate(field.value));
        }
    }, [field]);
    var datepickerRef = useRef(null);
    var handleCalendarClick = function () {
        var _a;
        (_a = datepickerRef === null || datepickerRef === void 0 ? void 0 : datepickerRef.current) === null || _a === void 0 ? void 0 : _a.setOpen(true);
    };
    return (React.createElement(Container, null,
        React.createElement(DatePicker, __assign({}, field, props, { selected: (!!field.value && new Date(field.value)) || new Date(), onChange: function (val) {
                setFieldValue(field.name, val);
            }, dateFormat: "MMMM d", ref: datepickerRef }, datePickerProps)),
        React.createElement(Icon, { src: calendar, onClick: handleCalendarClick })));
};
//# sourceMappingURL=DateSelector.js.map